<template>
  <v-container>
    <v-row wrap>
      <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="mb-0 pb-0">
        <v-card flat>
          <v-card-text class="pa-0 pt-6">
            <v-row class="grey lighten-4 mx-0 py-6 px-6">
              <v-col cols="12" sm="2" class="d-none d-sm-flex text-center">
                <v-avatar :size="150" color="blue lighten-5">
                  <v-img
                    fluid
                    :src="
                      current_user && current_user.foto
                        ? current_user.foto
                        : current_user && current_user.kelamin == 'P'
                        ? 'https://cdn.siap.id/s3/simpkb/asset%20img/guru-praktik-baik/img-default-perempuan.png'
                        : 'https://cdn.siap.id/s3/simpkb/asset%20img/guru-praktik-baik/img-default-laki.png'
                    "
                  >
                  </v-img>
                </v-avatar>
              </v-col>
              <v-col cols="12" sm="8" md="8" lg="8" xl="8" class="ml-3">
                <p class="headline black--text font-weight-bold mb-0 pb-0 pt-0 mt-n1">{{ pVal(current_user, "name") }}</p>
                <p class="py-0 my-0 caption">{{ pVal(current_user, "email") }}</p>
                <p v-if="!current_user.is_super_admin">
                  <v-alert v-if="!current_user.komunitas_id" icon="mdi-alert" cols="12" dense text type="warning" class="caption">
                    Belum bergabung dengan komunitas tertentu &nbsp;
                    <m-button outlined x-small color="orange" class="white--text ma-0 float-sm-right" textButton="Bergabung" action="pilih" @pilih="toSIMPKB()"></m-button>
                  </v-alert>
                  <span class="caption green--text" v-else>{{ pVal(current_user, "komunitas") }}</span>
                </p>
                <p class="my-4 pt-3" v-if="current_user.peran_dapodik">
                  <v-chip label color="blue lighten-5 blue--text"
                    ><v-icon color="blue">mdi-account</v-icon>&nbsp;{{ current_user.peran_dapodik.keterangan | toTitleCase }}
                    {{ current_user.jenjang ? current_user.jenjang.keterangan : "" }}</v-chip
                  >
                </p>
              </v-col>
            </v-row>
            <div class="py-3"></div>
            <v-row class="align-center justify-center py-4">
              <v-col cols="12" sm="6" md="3" lg="3" align-self="center">
                <m-button
                  isBlock
                  outlined
                  v-if="current_user.peranku.length > 0 || current_user.is_super_admin"
                  class="mt-1"
                  dark
                  color="primary lighten-1"
                  text-button="Daftar Ujian"
                  icon="mdi-arrow-left"
                  action="toKelola"
                  @toKelola="$router.push({ name: 'instansi.pilih' })"
                ></m-button>
              </v-col>
              <v-col cols="12" sm="6" md="3" lg="3" align-self="center">
                <m-button
                  isBlock
                  v-if="current_user.is_super_admin"
                  class="mt-1"
                  dark
                  color="primary lighten-1"
                  text-button="Periode Ujian"
                  icon="mdi-plus"
                  action="tambah"
                  @tambah="tambah"
                ></m-button>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <div class="py-3"></div>

    <v-row wrap class="pt-5">
      <v-col cols="12" class="text-h4 font-weight-bold mb-0 pb-0">Kelola Ujian</v-col>
      <v-col cols="12" sm="12" md="6" lg="6" xl="6" v-for="item in items" :key="item.id">
        <BlockCard
          :isKelola="true"
          :isReady="item.is_tutup ? false : item.is_rilis ? true : false"
          :title="item.nama"
          :item="item"
          :newSeries="item.is_new"
          :logo="item.cover"
          style="height: 100%"
          color="primary"
          @reload="load"
          @edit="edit(item)"
          @pilih="pilihInstansi(item)"
          to
        />
      </v-col>
      <Form ref="dlg" />
    </v-row>
    <Form ref="dlg" />
  </v-container>
</template>

<script>
function compare(a, b) {
  if (a.id < b.id) {
    return 1;
  }
  if (a.id > b.id) {
    return -1;
  }
  return 0;
}
import { SIMPKB } from "@/const";
import Form from "../../instansi/components/Form.vue";
export default {
  components: {
    BlockCard: () => import("@/components/BlockCard"),
    Form
  },
  data() {
    return {
      instansi: {},
      textSearch: "",
      items: [],
      current_page: 1,
      hsidebar: false,
      page: null,
      cp: 1,
      dialog: true,
      jenjangs: [],
      is_kelola: true
    };
  },
  activated() {
    this.dialog = true;
    this.$store.commit("main/setLDrawer", false);
  },
  mounted() {
    this.$store.commit("main/setLDrawer", false);
    this.current_page = 1;
    this.load();
  },
  methods: {
    add() {
      this.$refs.dlg.open().then(() => {
        this.load();
      });
    },
    updateJenjang() {
      this.$refs.dlg.open(this.current_user).then(() => {
        this.load();
      });
    },
    toSeri() {
      this.$router.push({
        name: "instansi.pilih"
      });
    },
    toSIMPKB() {
      window.open(SIMPKB, "_blank");
    },
    pencarian() {
      this.cp = 1;
      this.current_page = 1;
      this.load();
    },
    tambah() {
      this.$refs.dlg.open().then(() => {
        this.load();
      });
    },
    load() {
      return this.$store
        .dispatch("instansi/getKelola", {
          page: this.current_page,
          s: this.textSearch
        })
        .then(res => {
          this.page = res;
          this.items = res.sort(compare).filter(ins=>ins.is_gbb==0);
        })
        .catch(e => e);
    },
    edit(item) {
      this.$refs.dlg.open(item).then(() => {
        this.load();
      });
    },
    // eslint-disable-next-line
    save() {
      this.$validator
        .validateAll("form")
        .then(res => {
          if (!res) return Promise.reject();
          return res;
        })
        .then(() => {
          return this.$store.dispatch("instansi/create", this.instansi);
        })
        .then(res => {
          this.instansi.nama = "";
          this.pilihInstansi(res.data);
          this.$refs.dlg.resolve();
          return res;
        })
        .catch(e => e);
    },
    change() {
      this.load();
    },
    pilihInstansi(item) {
      return this.$store
        .dispatch("instansi/switchInstansi", item.id)
        .then(() => {
          this.$store.commit("main/setLDrawer", true);

          return this.$router.push({
            name: "beranda.admin",
            params: { instansi_id: item.id }
          });
        })
        .catch(e => e);
    }
  },
  watch: {
    hsidebar(n) {
      this.$store.commit("main/setHsidebar", n);
    }
  },
  computed: {
    is_disabled() {
      return this.CONFIG.SINGKRONISASI == "true" ? true : false;
    }
  }
};
</script>

<style></style>
